import {
  ON_START_CHECK_PLANING_USER,PROJEKT_GET_CHECK_PLANING_USER,
  PROJEKT_ON_START_GET_CARD_DETAILS,PROJEKT_ON_GET_CARD_DETAILS,PROJEKT_ON_ERROR_GET_GET_CARD_DETAILS,
  PROJEKT_ON_START_GET_FORTNOX_INVOICES_PROJECT,PROJEKT_ON_GET_FORTNOX_INVOICES_PROJECT,PROJEKT_ON_ERROR_GET_FORTNOX_INVOICES_PROJECT,
  PROJEKT_ON_START_GET_FORTNOX_PROJECT,PROJEKT_ON_GET_FORTNOX_PROJECT,PROJEKT_ON_ERROR_GET_FORTNOX_PROJECT,
  PROJEKT_ON_START_GET_PROJEKT,
  PROJEKT_ON_GET_PROJEKT,
  PROJEKT_ON_GET_ORGNR_COUNT_ALL,
  PROJEKT_ON_GET_PROJEKT_AUTOCOMPLETE,
	PROJEKT_ON_GET_BOARD_AUTOCOMPLETE,
  PROJEKT_ON_START_GET_PROJEKT_TIMELINE,
  PROJEKT_ON_GET_PROJEKT_TIMELINE,
  PROJEKT_ON_START_GET_PROJEKT_BY_FASER,
  PROJEKT_ON_START_GET_PROJEKT_TIME_REPORT,
  PROJEKT_ON_GET_PROJEKT_TIME_REPORT,
  ON_SAVE_PROJEKT_CALC_ITEMS,
  ON_START_SAVE_PROJEKT_CALC_ITEMS,  
  ON_ERROR_SAVE_PROJEKT_CALC_ITEMS, 

  PROJEKT_ON_START_GET_USERS_CALENDAR_EVENTS,
  PROJEKT_ON_ERROR_GET_USERS_CALENDAR_EVENTS,
  PROJEKT_ON_GET_USERS_CALENDAR_EVENTS,
  PROJEKT_ON_GET_PROJEKT_BY_FASER,
  PROJEKT_ON_START_UPDATE_PROJEKT,
  PROJEKT_ON_UPDATE_PROJEKT,
  PROJEKT_ON_ERROR_UPDATE_PROJEKT,
  PROJEKT_ON_START_GET_THIS_PROJEKT,PROJEKT_ON_START_GET_THIS_CPROJEKT,
  PROJEKT_ON_GET_THIS_PROJEKT,
  PROJEKT_ON_START_GET_BOARDS,
  PROJEKT_ON_GET_BOARDS,
  PROJEKT_ON_START_GET_THIS_BOARD,
  PROJEKT_ON_GET_THIS_BOARD,
  PROJEKT_ON_START_GET_DOKUMENT,
  PROJEKT_ON_GET_DOKUMENT,
  PROJEKT_ON_GET_TAGS,
  PROJEKT_ON_START_UPDATE,
  PROJEKT_ON_UPDATE,
  PROJEKT_ON_GET_THIS_BOARD_AKTIVITET,
  PROJEKT_ON_START_GET_THIS_BOARD_AKTIVITET,
  PROJEKT_ON_ERROR_GET_THIS_BOARD_AKTIVITET,
  PROJEKT_ON_GET_HISTORIK,
  PROJEKT_ON_GET_BOARD_TEMPLATES,
  PROJEKT_ON_UPDADE_BOARD_TEMPLATE,
  PROJEKT_ON_ERROR_UPDADE_BOARD_TEMPLATE,
  PROJEKT_ON_START_UPDADE_BOARD_TEMPLATE,
  PROJEKT_GET_REGISTERED_TIME,
  PROJEKT_GET_TIME_TYPES,
  PROJEKT_GET_CALENDAR_EVENTS,
	PROJEKT_START_GET_CALENDAR_EVENTS,
	PROJEKT_ERROR_GET_CALENDAR_EVENTS,
 	PROJEKT_UPDATE_CALENDAR_EVENT,
	PROJEKT_START_UPDATE_CALENDAR_EVENT,
	PROJEKT_ERROR_UPDATE_CALENDAR_EVENT,
  ON_OPEN_FILTER_PROJEKT,
  ON_ClOSE_FILTER_PROJEKT,
  SET_PROJEKT_FILTER,
  ON_OPEN_FILTER_PROJEKTKORT,
  ON_ClOSE_FILTER_PROJEKTKORT,
  SET_PROJEKTKORT_FILTER,
  ON_START_NEW_PROJEKT_KALKYL_ID,
  ON_NEW_PROJEKT_KALKYL_ID,
  ON_ERROR_NEW_PROJEKT_KALKYL_ID,
  ON_START_NEW_PROJEKT_ABOKALKYL_ID,
  ON_NEW_PROJEKT_ABOKALKYL_ID,
  ON_ERROR_NEW_PROJEKT_ABOKALKYL_ID,
  ON_START_GET_PROJEKT_KALKYL_ID,
  ON_GET_PROJEKT_KALKYL_ID,
  ON_ERROR_GET_PROJEKT_KALKYL_ID,
  ON_START_DELETE_PROJEKT_KALKYL_RAD,
  ON_DELETE_PROJEKT_KALKYL_RAD,
  ON_ERROR_DELETE_PROJEKT_KALKYL_RAD,
  ON_START_UPDATE_PROJEKT_KALKYL_RAD,
  ON_UPDATE_PROJEKT_KALKYL_RAD,
  ON_ERROR_UPDATE_PROJEKT_KALKYL_RAD,
  PROJEKT_ON_START_BUFFER_CARDS,
  PROJEKT_ON_ERROR_BUFFER_CARDS,
  PROJEKT_ON_BUFFER_CARDS,
  PROJEKT_ON_BUFFER_CARDS_BUFFERED,
  PROJEKT_ON_START_SEARCH_CARDS,
  PROJEKT_ON_ERROR_SEARCH_CARDS,
  PROJEKT_ON_SEARCH_CARDS,
  PROJEKT_ON_START_GET_TOOLTIPINFO,
  PROJEKT_ON_GET_TOOLTIPINFO,
  PROJEKT_ON_ERROR_GET_TOOLTIPINFO,
  PROJEKT_ON_START_GO_TO_BOARD,
  PROJEKT_ON_GO_TO_BOARD,
  PROJEKT_ON_ERROR_GO_TO_BOARD ,
  PROJEKT_ON_POST_TO_FLODE,
  PROJEKT_ON_START_POST_TO_FLODE,
  PROJEKT_ON_ERROR_POST_TO_FLODE,
  PROJEKT_ON_EDIT_TO_FLODE,
  PROJEKT_ON_START_EDIT_TO_FLODE,
  PROJEKT_ON_ERROR_EDIT_TO_FLODE,
  PROJEKT_ON_DELETE_TO_FLODE,
  PROJEKT_ON_START_DELETE_TO_FLODE,
  PROJEKT_ON_ERROR_DELETE_TO_FLODE,
  PROJEKT_ON_START_UPDATE_BOARD,
  PROJEKT_ON_UPDATE_BOARD,
  PROJEKT_ON_ERROR_UPDATE_BOARD,
  PROJEKT_SET_CURRENT_TAB_INDEX,
  PROJEKT_SET_SEARCH_TEXT,
  PROJEKT_ON_ADD_EXTERN_PART_BOARD,
  PROJEKT_ON_START_ADD_EXTERN_PART_BOARD,
  PROJEKT_ON_ERROR_ADD_EXTERN_PART_BOARD,
  PROJEKT_ON_GET_BOARD_BY_TOKEN,
  PROJEKT_ON_START_GET_BOARD_BY_TOKEN,
  PROJEKT_ON_ERROR_GET_BOARD_BY_TOKEN,
  PROJEKT_ON_GET_BOARD_LIST_BY_TOKEN,
	PROJEKT_ON_GET_BOARD_LIST_BY_USER,
  PROJEKT_ON_START_GET_BOARD_LIST_BY_TOKEN,
  PROJEKT_ON_ERROR_GET_BOARD_LIST_BY_TOKEN,
  PROJEKT_ON_RESET_BOARD_RESPONSE,
  PROJEKT_ON_START_UPDATE_PROJEKT_BY_META,
  PROJEKT_ON_UPDATE_PROJEKT_BY_META,
  PROJEKT_ON_ERROR_UPDATE_PROJEKT_BY_META,

  PROJEKT_KORT_ON_ADD_KOMMENTAR,
  PROJEKT_KORT_ON_START_ADD_KOMMENTAR,
  PROJEKT_KORT_ON_ERROR_ADD_KOMMENTAR,
  PROJEKT_KORT_ON_UPDATE_KOMMENTAR,
  PROJEKT_KORT_ON_START_UPDATE_KOMMENTAR,
  PROJEKT_KORT_ON_ERROR_UPDATE_KOMMENTAR,
  PROJEKT_KORT_ON_DELETE_KOMMENTAR,
  PROJEKT_KORT_ON_START_DELETE_KOMMENTAR,
  PROJEKT_KORT_ON_ERROR_DELETE_KOMMENTAR,
  PROJEKT_KORT_ON_ADD_MEDARBETARE,
  PROJEKT_KORT_ON_START_ADD_MEDARBETARE,
  PROJEKT_KORT_ON_ERROR_ADD_MEDARBETARE,
  PROJEKT_KORT_ON_DELETE_MEDARBETARE,
  PROJEKT_KORT_ON_START_DELETE_MEDARBETARE,
  PROJEKT_KORT_ON_ERROR_DELETE_MEDARBETARE,
  PROJEKT_KORT_ON_UPDATE_BESKRIVNING,
  PROJEKT_KORT_ON_START_UPDATE_BESKRIVNING,
  PROJEKT_KORT_ON_ERROR_UPDATE_BESKRIVNING,
  PROJEKT_KORT_ON_UPDATE_TITEL,
  PROJEKT_KORT_ON_START_UPDATE_TITEL,
  PROJEKT_KORT_ON_ERROR_UPDATE_TITEL,
  PROJEKT_KORT_ON_ADD_LABEL,
  PROJEKT_KORT_ON_START_ADD_LABEL,
  PROJEKT_KORT_ON_ERROR_ADD_LABEL,
  PROJEKT_KORT_ON_REMOVE_LABEL,
  PROJEKT_KORT_ON_START_REMOVE_LABEL,
  PROJEKT_KORT_ON_ERROR_REMOVE_LABEL,
  PROJEKT_KORT_ON_UPDATE_DEADLINE,
  PROJEKT_KORT_ON_START_UPDATE_DEADLINE,
  PROJEKT_KORT_ON_ERROR_UPDATE_DEADLINE,
  PROJEKT_KORT_ON_ADD_ATTATCHMENT,
  PROJEKT_KORT_ON_START_ADD_ATTATCHMENT,
  PROJEKT_KORT_ON_ERROR_ADD_ATTATCHMENT,
  PROJEKT_KORT_ON_DELETE_ATTATCHMENT,
  PROJEKT_KORT_ON_START_DELETE_ATTATCHMENT,
  PROJEKT_KORT_ON_ERROR_DELETE_ATTATCHMENT,
  PROJEKT_KORT_ON_UPDATE_STATUS,
  PROJEKT_KORT_ON_START_UPDATE_STATUS,
  PROJEKT_KORT_ON_ERROR_UPDATE_STATUS,
  PROJEKT_KORT_ON_MOVE_CARD,
  PROJEKT_KORT_ON_START_MOVE_CARD,
  PROJEKT_KORT_ON_ERROR_MOVE_CARD,
  PROJEKT_KORT_ON_MAKE_COVER,
  PROJEKT_KORT_ON_START_MAKE_COVER ,
  PROJEKT_KORT_ON_ERROR_MAKE_COVER,
  PROJEKT_KORT_ON_ADD_CHECKLIST,
  PROJEKT_KORT_ON_START_ADD_CHECKLIST,
  PROJEKT_KORT_ON_ERROR_ADD_CHECKLIST,
  PROJEKT_KORT_ON_UPDATE_CHECKLIST,
  PROJEKT_KORT_ON_START_UPDATE_CHECKLIST,
  PROJEKT_KORT_ON_ERROR_UPDATE_CHECKLIST,
  PROJEKT_KORT_ON_DELETE_CHECKLIST,
  PROJEKT_KORT_ON_START_DELETE_CHECKLIST,
  PROJEKT_KORT_ON_ERROR_DELETE_CHECKLIST,
  PROJEKT_KORT_ON_ADD_CHECKLIST_ITEM,
  PROJEKT_KORT_ON_START_ADD_CHECKLIST_ITEM,
  PROJEKT_KORT_ON_ERROR_ADD_CHECKLIST_ITEM,
  PROJEKT_KORT_ON_UPDATE_CHECKLIST_ITEM,
  PROJEKT_KORT_ON_START_UPDATE_CHECKLIST_ITEM,
  PROJEKT_KORT_ON_ERROR_UPDATE_CHECKLIST_ITEM,
  PROJEKT_KORT_ON_DELETE_CHECKLIST_ITEM,
  PROJEKT_KORT_ON_START_DELETE_CHECKLIST_ITEM,
  PROJEKT_KORT_ON_ERROR_DELETE_CHECKLIST_ITEM,
  PROJEKT_KORT_ON_FOLLOW_CARD, 
  PROJEKT_KORT_ON_START_FOLLOW_CARD,
  PROJEKT_KORT_ON_ERROR_FOLLOW_CARD, 
  PROJEKT_ON_RESET_PROJEKT_RESPONSE,
  PROJEKT_ON_START_GET_USERS_OUTLOOK_STATUS, 
  PROJEKT_ON_ERROR_GET_USERS_OUTLOOK_STATUS,
  PROJEKT_ON_GET_USERS_OUTLOOK_STATUS,
  PROJEKT_ON_START_GET_PLANNED_TIME_PRESET,
  PROJEKT_ON_ERROR_GET_PLANNED_TIME_PRESET,
  PROJEKT_ON_GET_PLANNED_TIME_PRESET,
  SET_ZERO_PROJECT
}  from '../constants/ActionTypes'
import {isUndefined,isEmpty, indexOf} from 'lodash'

import { translate } from "../util/intlHelper";

const INIT_STATE = {
  response: null,
  currentTabIndex: 1,
  Searchtext: "",
  currentProjektTooltipInfo: [],
  currentProjektTooltipInfoLoading: false,
  currentBoardCard: [],
  ProjectList: [],
  ProjectListAutoComplete: [],
	BoardListAutoComplete:[],
  ProjectListTimeline: [],
  ProjectListFaser: [],
  ProjectListTimeReport:[],
	ReportSummary:{ArbetadeH:0, FakturerbarH:0, PlaneradH: 0},
  TotalProjects: 0,
  currentProject: {},
  currentBoard: {},
  bufferCardsReady: false,
  bufferingCards: false,
  BoardListTemplates: [],
  BoardList:[],
  BoardListCount: 0,
  DocumentList:[],
  DocumentListCount: 0,
  DocumentLoading: true,
  fetchingData: true,
  boardDataFetched: false,
  ProjectTags: [],
  ProjectStats: null,
  BoardLoading: false,
  BoardSaving: false,
  BoardResponse: null,
  BoardAktivitet: [],
  BoardAktivitetLoading: false,
  ProjectHistory: [],
  RegisteredTime_Users: [],
  RegisteredTime_Users_Count: 0,
  RegisteredTime_Activity: [],
  RegisteredTime_Activity_Count: 0,
  RegisteredTime_Total_Hours: 0,
  PastDaysArray: [],
  buffferCardsArray: [],
  buffferToColumnId: 0,
  TimeTypes: [],
  CalendarEvents: [],
	CalendarEventsLoading:false,
  newData: true,
  ProjectLoading: false,
  ProjectListLoading: false,
  FilterProjektPopup:false,
  ProjektFilterOption: isUndefined(localStorage.ProjektFilter)?[]:JSON.parse(localStorage.ProjektFilter),
  FilterProjektKortPopup:false,
  ProjektKortFilterOption: isUndefined(localStorage.ProjektKortFilter)?[]:JSON.parse(localStorage.ProjektKortFilter),
  currentProjectKalkyl: [],
  cardSearchRes: [],
  FortnoxProject: {},
  FortNoxProjektFakturor: [],
  searchLoading: false,
  currentExternUser: {},
  currentExternErrorMsg: null,
  sortObj: isUndefined(localStorage.ProjektSortObj)?{column: 'sdate', Type: 0}:JSON.parse(localStorage.ProjektSortObj),
  TotalProjects_All:0,
  tokenBoardList:[],
  userBoardList:[],
  cardDetails:[],
  AlartPlaning:"",
	UserCalendarList: [],
	UserCalendarLoading: false,
	UserAvalibleArray: [],
	OutlookEventStatus: [],
	PlannedTimeCalendarPreset: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_ZERO_PROJECT: {
      return INIT_STATE;
    }
    case PROJEKT_SET_CURRENT_TAB_INDEX : {
      console.log('PROJEKT_SET_CURRENT_TAB_INDEX', action.payload)
      return {
        ...state,
        currentTabIndex: action.payload
      }
    }
    case PROJEKT_SET_SEARCH_TEXT : {
      console.log('PROJEKT_SET_SEARCH_TEXT', action.payload)
      return {
        ...state,
        Searchtext: action.payload
      }
    }
    case PROJEKT_ON_RESET_PROJEKT_RESPONSE : {
      console.log('PROJEKT_ON_RESET_PROJEKT_RESPONSE', action.payload)
      return {
        ...state,
        response: null
      }
    }
    case ON_START_NEW_PROJEKT_KALKYL_ID: {
      console.log("ON_START_NEW_PROJEKT_KALKYL_ID", action.payload)
      return {
        ...state
      }
    }
    case ON_NEW_PROJEKT_KALKYL_ID: {
      console.log("ON_NEW_PROJEKT_KALKYL_ID", action.payload)
      return {
        ...state,
        currentProjectKalkyl:action.payload.Kalkyl,
      }
    }

    case ON_SAVE_PROJEKT_CALC_ITEMS: {
      return {
        ...state,
        response: {type: 'success', msg: translate("Action.Save"), loading: false}, 
        currentProjectKalkyl:action.payload.Kalkyl,
      }
    }
    case ON_START_SAVE_PROJEKT_CALC_ITEMS: {
      return {
        ...state,
        response: {type: 'info', msg: translate("Action.saving"), loading: true}, 
        ProjectLoading: true
      }
    }
    case ON_ERROR_SAVE_PROJEKT_CALC_ITEMS: {
      return {
        ...state,
        response: {type: 'error', msg: translate("notification.error"), loading: false}, 
        ProjectLoading: false
      }
    }

    case ON_ERROR_NEW_PROJEKT_KALKYL_ID: {
      console.log("ON_ERROR_NEW_PROJEKT_KALKYL_ID", action.payload)
      return {
        ...state
      }
    }
    case ON_START_NEW_PROJEKT_ABOKALKYL_ID: {
      console.log("ON_START_NEW_PROJEKT_ABOKALKYL_ID", action.payload)
      return {
        ...state
      }
    }
    case ON_NEW_PROJEKT_ABOKALKYL_ID: {
      console.log("ON_NEW_PROJEKT_ABOKALKYL_ID", action.payload)
      return {
        ...state,
        currentProjectKalkyl:action.payload.Kalkyl,
      }
    }
    case ON_ERROR_NEW_PROJEKT_ABOKALKYL_ID: {
      console.log("ON_ERROR_NEW_PROJEKT_ABOKALKYL_ID", action.payload)
      return {
        ...state
      }
    }
    case ON_START_GET_PROJEKT_KALKYL_ID: {
      console.log("ON_START_GET_PROJEKT_KALKYL_ID", action.payload)
      return {
        ...state
      }
    }
    case PROJEKT_ON_GET_ORGNR_COUNT_ALL: {
      console.log("PROJEKT_ON_GET_ORGNR_COUNT_ALL", action.payload)
      return {
        ...state,
        TotalProjects_All:action.payload.Count,
      }
    }
    case ON_GET_PROJEKT_KALKYL_ID: {
      console.log("ON_GET_PROJEKT_KALKYL_ID", action.payload)
      return {
        ...state,
        currentProjectKalkyl:action.payload.Kalkyl,        
      }
    }
    case ON_ERROR_GET_PROJEKT_KALKYL_ID: {
      console.log("ON_ERROR_GET_PROJEKT_KALKYL_ID", action.payload)
      return {
        ...state
      }
    }
    case ON_START_DELETE_PROJEKT_KALKYL_RAD: {
      console.log("ON_START_DELETE_PROJEKT_KALKYL_RAD", action.payload)
      return {
        ...state
      }
    }
    case ON_DELETE_PROJEKT_KALKYL_RAD: {
      console.log("ON_DELETE_PROJEKT_KALKYL_RAD", action.payload)
      return {
        ...state,
        currentProjectKalkyl:action.payload.Kalkyl,
      }
    }
    case ON_ERROR_DELETE_PROJEKT_KALKYL_RAD: {
      console.log("ON_ERROR_DELETE_PROJEKT_KALKYL_RAD", action.payload)
      return {
        ...state
      }
    }
    case ON_START_UPDATE_PROJEKT_KALKYL_RAD: {
      console.log("ON_START_UPDATE_PROJEKT_KALKYL_RAD", action.payload)
      return {
        ...state
      }
    }
    case ON_UPDATE_PROJEKT_KALKYL_RAD: {
      console.log("ON_UPDATE_PROJEKT_KALKYL_RAD", action.payload)
      return {
        ...state,
        currentProjectKalkyl:action.payload.Kalkyl,
      }
    }
    case ON_ERROR_UPDATE_PROJEKT_KALKYL_RAD: {
      console.log("ON_UPDATE_PROJEKT_KALKYL_RAD", action.payload)
      return {
        ...state
      }
    }
    case PROJEKT_ON_START_GET_TOOLTIPINFO: {
      console.log("PROJEKT_ON_START_GET_TOOLTIPINFO", action.payload)
      return {
        ...state,
        currentProjektTooltipInfo: [],
        currentProjektTooltipInfoLoading: true,
      }
    }
    case PROJEKT_ON_GET_TOOLTIPINFO: {
      console.log("PROJEKT_ON_GET_TOOLTIPINFO", action.payload)
      return {
        ...state,
        currentProjektTooltipInfo: action.payload.ProjektTooltipInfo,
        currentProjektTooltipInfoLoading: false,
      }
    }
    case PROJEKT_ON_ERROR_GET_TOOLTIPINFO: {
      console.log("PROJEKT_ON_ERROR_GET_TOOLTIPINFO", action.payload)
      return {
        ...state,
        currentProjektTooltipInfo: [],
        currentProjektTooltipInfoLoading: false,
      }
    }



    case ON_OPEN_FILTER_PROJEKT: {
      console.log("ON_OPEN_FILTER_PROJEKT", action.payload)
      return {
        ...state, 
        FilterProjektPopup:true,
        
        ProjektFilterOption:isUndefined(localStorage.ProjektFilter)?[]:JSON.parse(localStorage.ProjektFilter)
      }
    }
    case ON_ClOSE_FILTER_PROJEKT: {
      console.log("ON_ClOSE_FILTER_PROJEKT", action.payload)
      return {...state, FilterProjektPopup:false}
    }
    case SET_PROJEKT_FILTER: {
      console.log("SET_PROJEKT_FILTER", action.payload)
      localStorage.removeItem("ProjektFilter");
      localStorage.setItem("ProjektFilter", JSON.stringify(action.payload));
      return {...state, ProjektFilterOption: action.payload}
    }

    case ON_OPEN_FILTER_PROJEKTKORT: {
      console.log("ON_OPEN_FILTER_PROJEKTKORT", action.payload)
      return {
        ...state, 
        FilterProjektKortPopup:true,
        
        ProjektKortFilterOption:isUndefined(localStorage.ProjektKortFilter)?[]:JSON.parse(localStorage.ProjektKortFilter)
      }
    }
    case ON_ClOSE_FILTER_PROJEKTKORT: {
      console.log("ON_ClOSE_FILTER_PROJEKTKORT", action.payload)
      return {...state, FilterProjektKortPopup:false}
    }
    case SET_PROJEKTKORT_FILTER: {
      console.log("SET_PROJEKTKORT_FILTER", action.payload)
      localStorage.removeItem("ProjektKortFilter");
      localStorage.setItem("ProjektKortFilter", JSON.stringify(action.payload));
      return {...state, ProjektKortFilterOption: action.payload}
    }
    case PROJEKT_ON_START_GET_PROJEKT: {
      console.log("PROJEKT_ON_START_GET_PROJEKT", action)
      return {
        ...state,
        //ProjectList: [],
        //TotalProjects: 0,
        ProjectListLoading: true
      }
    }
    case PROJEKT_ON_GET_PROJEKT: {
      console.log("PROJEKT_ON_GET_PROJEKT", action)
      
      localStorage.removeItem("ProjektSortObj");
      if(!isUndefined(JSON.stringify(action.payload.SortObj))){
      localStorage.setItem("ProjektSortObj", JSON.stringify(action.payload.SortObj));
      }
      return {
        ...state,
        ProjectList: action.payload.Projects,
        TotalProjects: action.payload.Count,
        sortObj: isUndefined(JSON.stringify(action.payload.SortObj))?{"column":"sdate","Type":0}:action.payload.SortObj,
        ProjectListLoading: false
      }
    }

    
    case PROJEKT_ON_START_UPDATE_PROJEKT_BY_META: {
      return {
        ...state,
        ProjectListLoading: true
      }
    }
    case PROJEKT_ON_UPDATE_PROJEKT_BY_META: {
      return {
        ...state,
        ProjectListLoading: false
      }
    }
    case PROJEKT_ON_ERROR_UPDATE_PROJEKT_BY_META: {
      return {
        ...state,
        ProjectListLoading: false
      }
    }

    case PROJEKT_ON_GET_PROJEKT_AUTOCOMPLETE: {
      console.log("PROJEKT_ON_GET_PROJEKT_AUTOCOMPLETE", action)
      return {
        ...state,
        ProjectListAutoComplete: action.payload.Projects,
        TotalProjects: action.payload.Count,
        ProjectLoading: false
      }
    }
    case PROJEKT_ON_GET_BOARD_AUTOCOMPLETE: {
      console.log("PROJEKT_ON_GET_BOARD_AUTOCOMPLETE", action)
      return {
        ...state,
        BoardListAutoComplete: action.payload.boards,
        ProjectLoading: false
      }
    }
    case PROJEKT_ON_START_GET_PROJEKT_TIMELINE: {
      console.log("PROJEKT_ON_START_GET_PROJEKT_TIMELINE", action)
      return {
        ...state,
        ProjectListTimeline: [],
        ProjectLoading: true
      }
    }
    case PROJEKT_ON_GET_PROJEKT_TIMELINE: {
      console.log("PROJEKT_ON_GET_PROJEKT_TIMELINE", action)
      return {
        ...state,
        ProjectListTimeline: action.payload.ProjectsTimeline,
        ProjectLoading: false
      }
    }
    case PROJEKT_ON_START_GET_PROJEKT_BY_FASER: {
      console.log("PROJEKT_ON_START_GET_PROJEKT_TIMELINE", action)
      return {
        ...state,
        ProjectListFaser: [],
        ProjectLoading: true
      }
    }
    case PROJEKT_ON_GET_PROJEKT_BY_FASER: {
      console.log("PROJEKT_ON_GET_PROJEKT_TIMELINE", action)
      return {
        ...state,
        ProjectListFaser: action.payload.ProjectListFaser,
        ProjectLoading: false
      }
    }
    case PROJEKT_ON_START_GET_PROJEKT_TIME_REPORT: {
      console.log("PROJEKT_ON_START_GET_PROJEKT_TIME_REPORT", action)
      return {
        ...state,
        ProjectListTimeReport: action.payload.init ? [] : state.ProjectListTimeReport,
        ProjectListPlannedReport: action.payload.init ? [] : state.ProjectListPlannedReport,
				ReportSummary:action.payload.init ? {ArbetadeH:0, FakturerbarH:0, PlaneradH: 0}: state.ReportSummary,
        ProjectLoading: action.payload.init ? true : state.ProjectLoading
      }
    }
    case PROJEKT_ON_GET_PROJEKT_TIME_REPORT: {
      console.log("PROJEKT_ON_GET_PROJEKT_TIME_REPORT", action)
      return {
        ...state,
        ProjectListTimeReport: action.payload.ProjectListTimeReport,
        ProjectListPlannedReport: action.payload.ProjectListPlannedReport,
				ReportSummary:action.payload.ReportSummary,
        ProjectLoading: false
      }
    }
    case PROJEKT_ON_START_GET_THIS_CPROJEKT:{
      return {
        ...state,
        response: null,
      }
    }
    case PROJEKT_ON_START_GET_THIS_PROJEKT: {
      console.log("PROJEKT_ON_START_GET_THIS_PROJEKT", action)
      return {
        ...state,
        response: null,
        BoardListTemplates:[],
        ProjectTags: [],
        currentProject: {},
        BoardList: [],
        DocumentList:[],
        DocumentListCount: 0,
        DocumentLoading: true,
        ProjectStats: null,
        ProjectHistory:[],
        RegisteredTime_Users: [],
        RegisteredTime_Users_Count: 0,
        RegisteredTime_Activity: [],
        RegisteredTime_Activity_Count: 0,
        RegisteredTime_Total_Hours: 0,
        PastDaysArray: [],
        TimeTypes: [],
        CalendarEvents: [],
				CalendarEventsLoading:false,
        ProjectLoading: true
      }
    }
    case PROJEKT_ON_GET_THIS_PROJEKT: {
      console.log("PROJEKT_ON_GET_THIS_PROJEKT", action)
      return {
        ...state,
        currentProject: action.payload.Project,
        ProjectStats: action.payload.ProjectStats,
        ProjectLoading: false
      }
    }

		case PROJEKT_ON_START_GET_USERS_CALENDAR_EVENTS: {
      return {...state, response: null, UserCalendarLoading: true, UserCalendarList: []}
		}
		case PROJEKT_ON_ERROR_GET_USERS_CALENDAR_EVENTS: {
      return {...state, response: {type: 'error', msg: action.payload.message, loading: false}, UserCalendarLoading: false, UserCalendarList: []}
		}
		case PROJEKT_ON_GET_USERS_CALENDAR_EVENTS: {
      return {...state, response: null, UserCalendarLoading: false, UserCalendarList: action.payload.UserCalendarList}
		}
    case PROJEKT_ON_START_UPDATE_PROJEKT: {
      return {...state, response: {type: 'info', msg: translate("Action.Project.updating"), loading: true}, ProjectLoading: true}
    }
    case PROJEKT_ON_UPDATE_PROJEKT: {
      return {...state, response: {type: 'success', msg: action.payload.message, loading: false}, ProjectLoading: false}
    }
    case PROJEKT_ON_ERROR_UPDATE_PROJEKT: {
      return {...state, response: {type: 'error', msg: action.payload.message, loading: false}, ProjectLoading: false}
    }

    case PROJEKT_KORT_ON_ADD_KOMMENTAR: {
      return {...state, BoardResponse: {success: true, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_START_ADD_KOMMENTAR: {
      return {...state, BoardResponse: null, BoardSaving: true}
    }
    case PROJEKT_KORT_ON_ERROR_ADD_KOMMENTAR: {
      return {...state, BoardResponse: {success: false, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_UPDATE_KOMMENTAR: {
      return {...state, BoardResponse: {success: true, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_START_UPDATE_KOMMENTAR: {
      return {...state, BoardResponse: null, BoardSaving: true}
    }
    case PROJEKT_KORT_ON_ERROR_UPDATE_KOMMENTAR: {
      return {...state, BoardResponse: {success: false, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_DELETE_KOMMENTAR: {
      return {...state, BoardResponse: {success: true, message: action.payload.message, type:'warning' }, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_START_DELETE_KOMMENTAR: {
      return {...state, BoardResponse: null, BoardSaving: true}
    }
    case PROJEKT_KORT_ON_ERROR_DELETE_KOMMENTAR: {
      return {...state, BoardResponse: {success: false, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_ADD_MEDARBETARE: {
      return {...state, BoardResponse: {success: true, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_START_ADD_MEDARBETARE: {
      return {...state, BoardResponse: null, BoardSaving: true}
    }
    case PROJEKT_KORT_ON_ERROR_ADD_MEDARBETARE: {
      return {...state, BoardResponse: {success: false, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_DELETE_MEDARBETARE: {
      return {...state, BoardResponse: {success: true, message: action.payload.message, type:'warning'}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_START_DELETE_MEDARBETARE: {
      return {...state, BoardResponse: null, BoardSaving: true}
    }
    case PROJEKT_KORT_ON_ERROR_DELETE_MEDARBETARE: {
      return {...state, BoardResponse: {success: false, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_UPDATE_BESKRIVNING: {
      return {...state, BoardResponse: {success: true, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_START_UPDATE_BESKRIVNING: {
      return {...state, BoardResponse: null, BoardSaving: true}
    }
    case PROJEKT_KORT_ON_ERROR_UPDATE_BESKRIVNING: {
      return {...state, BoardResponse: {success: false, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_UPDATE_TITEL: {
      return {...state, BoardResponse: {success: true, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_START_UPDATE_TITEL: {
      return {...state, BoardResponse: null, BoardSaving: true}
    }
    case PROJEKT_KORT_ON_ERROR_UPDATE_TITEL: {
      return {...state, BoardResponse: {success: false, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_ADD_LABEL: {
      return {...state, BoardResponse: {success: true, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_START_ADD_LABEL: {
      return {...state, BoardResponse: null, BoardSaving: true}
    }
    case PROJEKT_KORT_ON_ERROR_ADD_LABEL: {
      return {...state, BoardResponse: {success: false, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_REMOVE_LABEL: {
      return {...state, BoardResponse: {success: true, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_START_REMOVE_LABEL: {
      return {...state, BoardResponse: null, BoardSaving: true}
    }
    case PROJEKT_KORT_ON_ERROR_REMOVE_LABEL: {
      return {...state, BoardResponse: {success: false, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_UPDATE_DEADLINE: {
      return {...state, BoardResponse: {success: true, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_START_UPDATE_DEADLINE: {
      return {...state, BoardResponse: null, BoardSaving: true}
    }
    case PROJEKT_KORT_ON_ERROR_UPDATE_DEADLINE: {
      return {...state, BoardResponse: {success: false, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_ADD_ATTATCHMENT: {
      return {...state, BoardResponse: {success: true, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_START_ADD_ATTATCHMENT: {
      return {...state, BoardResponse: null, BoardSaving: true}
    }
    case PROJEKT_KORT_ON_ERROR_ADD_ATTATCHMENT: {
      return {...state, BoardResponse: {success: false, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_DELETE_ATTATCHMENT: {
      return {...state, BoardResponse: {success: true, message: action.payload.message, type:'warning'}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_START_DELETE_ATTATCHMENT: {
      return {...state, BoardResponse: null, BoardSaving: true}
    }
    case PROJEKT_KORT_ON_ERROR_DELETE_ATTATCHMENT: {
      return {...state, BoardResponse: {success: false, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_UPDATE_STATUS: {
      return {...state, BoardResponse: {success: true, message: action.payload.message, type: action.payload.type}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_START_UPDATE_STATUS: {
      return {...state, BoardResponse: null, BoardSaving: true}
    }
    case PROJEKT_KORT_ON_ERROR_UPDATE_STATUS: {
      return {...state, BoardResponse: {success: false, message: action.payload.message, type: action.payload.type}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_MOVE_CARD: {
      return {...state, BoardResponse: {success: true, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_START_MOVE_CARD: {
      return {...state, BoardResponse: null, BoardSaving: true}
    }
    case PROJEKT_KORT_ON_ERROR_MOVE_CARD: {
      return {...state, BoardResponse: {success: false, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_MAKE_COVER: {
      return {...state, BoardResponse: {success: true, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_START_MAKE_COVER : {
      return {...state, BoardResponse: null, BoardSaving: true}
    }
    case PROJEKT_KORT_ON_ERROR_MAKE_COVER: {
      return {...state, BoardResponse: {success: false, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_ADD_CHECKLIST: {
      return {...state, BoardResponse: {success: true, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_START_ADD_CHECKLIST: {
      return {...state, BoardResponse: null, BoardSaving: true}
    }
    case PROJEKT_KORT_ON_ERROR_ADD_CHECKLIST: {
      return {...state, BoardResponse: {success: false, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_UPDATE_CHECKLIST: {
      return {...state, BoardResponse: {success: true, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_START_UPDATE_CHECKLIST: {
      return {...state, BoardResponse: null, BoardSaving: true}
    }
    case PROJEKT_KORT_ON_ERROR_UPDATE_CHECKLIST: {
      return {...state, BoardResponse: {success: false, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_FOLLOW_CARD: {
      return {...state, BoardResponse: {success: true, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_START_FOLLOW_CARD: {
      return {...state, BoardResponse: null, BoardSaving: true}
    }
    case PROJEKT_KORT_ON_ERROR_FOLLOW_CARD: {
      return {...state, BoardResponse: {success: false, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_DELETE_CHECKLIST: {
      return {...state, BoardResponse: {success: true, message: action.payload.message, type:'warning'}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_START_DELETE_CHECKLIST: {
      return {...state, BoardResponse: null, BoardSaving: true}
    }
    case PROJEKT_KORT_ON_ERROR_DELETE_CHECKLIST: {
      return {...state, BoardResponse: {success: false, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_ADD_CHECKLIST_ITEM: {
      return {...state, BoardResponse: {success: true, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_START_ADD_CHECKLIST_ITEM: {
      return {...state, BoardResponse: null, BoardSaving: true}
    }
    case PROJEKT_KORT_ON_ERROR_ADD_CHECKLIST_ITEM: {
      return {...state, BoardResponse: {success: false, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_UPDATE_CHECKLIST_ITEM: {
      return {...state, BoardResponse: {success: true, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_START_UPDATE_CHECKLIST_ITEM: {
      return {...state, BoardResponse: null, BoardSaving: true}
    }
    case PROJEKT_KORT_ON_ERROR_UPDATE_CHECKLIST_ITEM: {
      return {...state, BoardResponse: {success: false, message: action.payload.message}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_DELETE_CHECKLIST_ITEM: {
      return {...state, BoardResponse: {success: true, message: action.payload.message, type:'warning'}, BoardSaving: false}
    }
    case PROJEKT_KORT_ON_START_DELETE_CHECKLIST_ITEM: {
      return {...state, BoardResponse: null, BoardSaving: true}
    }
    case PROJEKT_KORT_ON_ERROR_DELETE_CHECKLIST_ITEM: {
      return {...state, BoardResponse: {success: false, message: action.payload.message}, BoardSaving: false}
    }

    case PROJEKT_ON_START_UPDADE_BOARD_TEMPLATE: {
      return {...state, response: null}
    }
    case PROJEKT_ON_UPDADE_BOARD_TEMPLATE: {
      return {...state, response: {type: 'success', msg: action.payload.message, loading: false}}
    }
    case PROJEKT_ON_ERROR_UPDADE_BOARD_TEMPLATE: {
      return {...state, response: {type: 'error', msg: action.payload.message, loading: false}}
    }
    case PROJEKT_ON_GET_HISTORIK: {
      console.log("PROJEKT_ON_GET_HISTORIK", action)
      return {
        ...state,
        ProjectHistory: action.payload
      }
    }
    case PROJEKT_ON_START_GET_BOARDS: {
      console.log("PROJEKT_ON_START_GET_BOARDS", action)
      return {
        ...state,
        // BoardList: []
      }
    }
    case PROJEKT_ON_GET_BOARDS: {
      console.log("PROJEKT_ON_GET_BOARDS", action)
      return {
        ...state,
        BoardList: action.payload.boards,
        BoardListCount: action.payload.Count,
      }
    }
    case PROJEKT_ON_GET_BOARD_TEMPLATES: {
      return {
        ...state,
        BoardListTemplates: action.payload
      }
    }
    case PROJEKT_ON_START_GET_THIS_BOARD: {
      console.log("PROJEKT_ON_START_GET_THIS_BOARD", action)
      const Init = action.payload
      return {
        ...state,
        fetchingData: true,
        BoardResponse: null,
        currentBoard: isUndefined(Init) ? state.currentBoard : {},
        BoardLoading: isUndefined(Init) ? false : true,
      }
    }
    case PROJEKT_ON_GET_THIS_BOARD: {
      console.log("PROJEKT_ON_GET_THIS_BOARD", action)
      if(!action.payload.newData) return {...state, newData: false, fetchingData: false, boardDataFetched: true}
      return {
        ...state,
        fetchingData: false,
        newData: true,
        currentBoard: action.payload.board,
        boardDataFetched: true,
        BoardLoading: false
      }
    }

    case PROJEKT_ON_START_UPDATE_BOARD: {
      console.log("PROJEKT_ON_START_UPDATE_BOARD", action.payload)
      return {
        ...state
      }
    }
    case PROJEKT_ON_UPDATE_BOARD: {
      console.log("PROJEKT_ON_UPDATE_BOARD", action.payload)
      return {
        ...state,
        currentBoard: {
          ...state.currentBoard,
          ...action.payload
        }
      }
    }
    case PROJEKT_ON_ERROR_UPDATE_BOARD: {
      console.log("PROJEKT_ON_ERROR_UPDATE_BOARD", action.payload)
      return {
        ...state
      }
    }

    case PROJEKT_ON_START_GET_THIS_BOARD_AKTIVITET: {
      console.log("PROJEKT_ON_START_GET_THIS_BOARD_AKTIVITET", action)
      return {
        ...state,
        BoardAktivitet: [],
        BoardAktivitetLoading: true,
      }
    }
    case PROJEKT_ON_ERROR_GET_THIS_BOARD_AKTIVITET: {
      console.log("PROJEKT_ON_ERROR_GET_THIS_BOARD_AKTIVITET", action)
      return {
        ...state,
        BoardAktivitet: [],
        BoardAktivitetLoading: false,
      }
    }
    case PROJEKT_ON_GET_THIS_BOARD_AKTIVITET: {
      console.log("PROJEKT_ON_GET_THIS_BOARD_AKTIVITET", action)
      return {
        ...state,
        BoardAktivitet: action.payload,
        BoardAktivitetLoading: false,
      }
    }
    case PROJEKT_ON_START_GET_DOKUMENT:{
      console.log("PROJEKT_ON_START_GET_DOKUMENT",action)
      return {
        ...state,
        // DocumentList:[],
        // DocumentListCount: 0
      }
    }
    case PROJEKT_ON_GET_DOKUMENT:{
      console.log("PROJEKT_ON_GET_DOKUMENT",action)
      return {
        ...state,
        DocumentList: action.payload.Documents,
        DocumentListCount: action.payload.Count,
        DocumentLoading: false
      }
    }
    case PROJEKT_ON_GET_TAGS:{
      console.log("PROJEKT_ON_GET_TAGS",action)
      return {
        ...state,
        ProjectTags: action.payload
      }
    }
    case PROJEKT_ON_START_UPDATE:{
      console.log("PROJEKT_ON_START_UPDATE",action)
      return {
        ...state,
        BoardSaving: true,
        BoardResponse: null
      }
    }
    case PROJEKT_ON_UPDATE:{
      console.log("PROJEKT_ON_UPDATE",action)
      return {
        ...state,
        BoardSaving: false,
        BoardResponse: action.payload
      }
    }
    case PROJEKT_GET_REGISTERED_TIME: {
      return {
        ...state,
        RegisteredTime_Users_Count:  action.payload.RegistreradeCount,
        RegisteredTime_Activity_Count: action.payload.AktivitetCount,
        RegisteredTime_Users: action.payload.Registrerade,
        RegisteredTime_Activity: action.payload.Aktivitet,
        RegisteredTime_Total_Hours: isEmpty(action.payload.TotalArbetadH) ? 0 : action.payload.TotalArbetadH[0].TotalArbetadH,
        PastDaysArray: action.payload.PastDaysArray
      }
    }
    case PROJEKT_GET_TIME_TYPES: {
      return {
        ...state,
        TimeTypes: action.payload
      }
    }
    case PROJEKT_GET_CALENDAR_EVENTS: {
      return {
        ...state,
				CalendarEventsLoading: false,
        CalendarEvents: action.payload,
				// response: {type: 'success', msg: "Planering har hämntats", loading: false},
      }
    }
		case PROJEKT_START_GET_CALENDAR_EVENTS: {
			return {
				...state,
				CalendarEventsLoading: true,
				// response: {type: 'info', msg: "Hämtar planering", loading: true},
        // CalendarEvents: []
			}
		}
		case PROJEKT_ERROR_GET_CALENDAR_EVENTS: {
			return {
				...state,
				CalendarEventsLoading: false,
        CalendarEvents: [],
				response: {type: 'error', msg: translate("Error.Project.Calendar.Event.get"), loading: false},
			}
		}
		case PROJEKT_UPDATE_CALENDAR_EVENT: {
			return {
				...state,
				response: {type: 'success', msg: translate("Action.Project.Calendar.Event.update"), loading: false},
			}
		}
		case PROJEKT_START_UPDATE_CALENDAR_EVENT: {
			return {
				...state,
				response: {type: 'info', msg: translate("Action.Project.Calendar.Event.updating"), loading: true},
			}
		}
		case PROJEKT_ERROR_UPDATE_CALENDAR_EVENT: {
			return {
				...state,
				response: {type: 'error', msg: translate("Error.Project.Calendar.Event.update"), loading: false},
			}
		}
		case PROJEKT_ON_START_GET_USERS_OUTLOOK_STATUS: {
			return {
				...state,
				OutlookEventStatus: []
			}
		}
		case PROJEKT_ON_ERROR_GET_USERS_OUTLOOK_STATUS: {
      return {
        ...state,
				OutlookEventStatus: []
      }
		}
		case PROJEKT_ON_GET_USERS_OUTLOOK_STATUS: {
      return {
        ...state,
				OutlookEventStatus: action.payload.OutlookEventStatus
      }
		}

 	 	case PROJEKT_ON_START_GET_PLANNED_TIME_PRESET: {
			return {
				...state,
				PlannedTimeCalendarPreset: []
			}
		}
 		case PROJEKT_ON_ERROR_GET_PLANNED_TIME_PRESET: {
			return {
				...state,
				PlannedTimeCalendarPreset: []
			}
		}
  	case PROJEKT_ON_GET_PLANNED_TIME_PRESET: {
			return {
				...state,
				PlannedTimeCalendarPreset: action.payload.PlannedTimeCalendarPreset
			}
		}
    //ON_START_CHECK_PLANING_USER,PROJEKT_GET_CHECK_PLANING_USER,
    case ON_START_CHECK_PLANING_USER: {
      return {
        ...state,
        UserAvalibleArray: []
      }
    }
    case PROJEKT_GET_CHECK_PLANING_USER: {
      return {
        ...state,
        UserAvalibleArray: action.payload.UserAvalibleArray
      }
    }
    //
    case PROJEKT_ON_START_BUFFER_CARDS: {
      console.log('PROJEKT_ON_START_BUFFER_CARDS', action.payload)
      return {
        bufferCardsReady: false,
        bufferingCards: true,
        buffferCardsArray: [],
        buffferToColumnId: 0,
        ...state,
      }
    }
    case PROJEKT_ON_ERROR_BUFFER_CARDS: {
      console.log('PROJEKT_ON_ERROR_BUFFER_CARDS', action.payload)
      return {
        bufferCardsReady: false,
        bufferingCards: false,
        buffferCardsArray: [],
        buffferToColumnId: 0,
        ...state,
      }
    }
    case PROJEKT_ON_BUFFER_CARDS: {
      console.log('PROJEKT_ON_BUFFER_CARDS', action.payload)
      let newColumns = state.currentBoard.columns
      let column = newColumns.find(c => c.ColumnId === action.payload.ColumnId)
      let newColumn = {...column, cards: column.cards.concat(action.payload.finalCards)}
      let newColumnIndex = indexOf( state.currentBoard.columns, column)

      newColumns.splice(newColumnIndex, 1)
      newColumns.splice(newColumnIndex, 0, newColumn)

      console.log(newColumn)

      return {
        ...state,
        bufferCardsReady: true,
        bufferingCards: false,
        buffferCardsArray: action.payload.finalCards,
        buffferToColumnId: action.payload.ColumnId,
      }
    }

    case PROJEKT_ON_START_SEARCH_CARDS: {
      console.log('PROJEKT_ON_START_SEARCH_CARDS', action.payload)
      return {
        ...state,
        cardSearchRes: [],
        searchLoading: true,
      }
    }
    case PROJEKT_ON_ERROR_SEARCH_CARDS: {
      console.log('PROJEKT_ON_ERROR_SEARCH_CARDS', action.payload)
      return {
        ...state,
        cardSearchRes: [],
        searchLoading: false,
      }
    }
    case PROJEKT_ON_SEARCH_CARDS: {
      console.log('PROJEKT_ON_SEARCH_CARDS', action.payload)

      return {
        ...state,
        cardSearchRes: action.payload,
        searchLoading: false,
      }
    }
    case PROJEKT_ON_BUFFER_CARDS_BUFFERED: {
      return {
        ...state,
        bufferCardsReady: false,
        buffferCardsArray: [],
        buffferToColumnId: 0,
      }
    }

    case PROJEKT_ON_START_GO_TO_BOARD: {
      console.log('PROJEKT_ON_START_GO_TO_BOARD', action.payload)
      return {
        ...state,
        currentBoardCard: []
      }
    } 
    case PROJEKT_ON_GO_TO_BOARD: {
      console.log('PROJEKT_ON_GO_TO_BOARD', action.payload)
      return {
        ...state,
        currentBoardCard: action.payload
      }
    }
    case PROJEKT_ON_ERROR_GO_TO_BOARD: {
      console.log('PROJEKT_ON_ERROR_GO_TO_BOARD', action.payload)
      return {
        ...state,
        currentBoardCard: []
      }
    }
    case PROJEKT_ON_POST_TO_FLODE: {
      console.log('PROJEKT_ON_POST_TO_FLODE', action.payload)
      return {
        ...state,
        currentProject: {
          ...state.currentProject,
          Flode: action.payload
        }
      }
    }
    case PROJEKT_ON_START_POST_TO_FLODE: {
      console.log('PROJEKT_ON_START_POST_TO_FLODE', action.payload)
      return {
        ...state,
      }
    }
    case PROJEKT_ON_ERROR_POST_TO_FLODE: {
      console.log('PROJEKT_ON_ERROR_POST_TO_FLODE', action.payload)
      return {
        ...state,
      }
    }
    case PROJEKT_ON_EDIT_TO_FLODE: {
      console.log('PROJEKT_ON_EDIT_TO_FLODE', action.payload)
      return {
        ...state,
        currentProject: {
          ...state.currentProject,
          Flode: action.payload
        }
      }
    }
    case PROJEKT_ON_START_EDIT_TO_FLODE: {
      console.log('PROJEKT_ON_START_EDIT_TO_FLODE', action.payload)
      return {
        ...state,
      }
    }
    case PROJEKT_ON_ERROR_EDIT_TO_FLODE: {
      console.log('PROJEKT_ON_ERROR_EDIT_TO_FLODE', action.payload)
      return {
        ...state,
      }
    }
    case PROJEKT_ON_DELETE_TO_FLODE: {
      console.log('PROJEKT_ON_DELETE_TO_FLODE', action.payload)
      return {
        ...state,
        currentProject: {
          ...state.currentProject,
          Flode: action.payload
        }
      }
    }
    case PROJEKT_ON_START_DELETE_TO_FLODE: {
      console.log('PROJEKT_ON_START_DELETE_TO_FLODE', action.payload)
      return {
        ...state,
      }
    }
    case PROJEKT_ON_ERROR_DELETE_TO_FLODE: {
      console.log('PROJEKT_ON_ERROR_DELETE_TO_FLODE', action.payload)
      return {
        ...state,
      }
    }
    //PROJEKT_ON_START_GET_FORTNOX_PROJECT,PROJEKT_ON_GET_FORTNOX_PROJECT,PROJEKT_ON_ERROR_GET_FORTNOX_PROJECT,
    case PROJEKT_ON_START_GET_FORTNOX_PROJECT: {
      console.log('PROJEKT_ON_START_GET_FORTNOX_PROJECT', action.payload)
      return {
        ...state
      }
    }
    case PROJEKT_ON_GET_FORTNOX_PROJECT: {
      console.log('PROJEKT_ON_GET_FORTNOX_PROJECT', action.payload)
      return {
        ...state,
        FortnoxProject: action.payload.FortNoxProjekt
      }
    }
    case PROJEKT_ON_ERROR_GET_FORTNOX_PROJECT: {
      console.log('PROJEKT_ON_ERROR_GET_FORTNOX_PROJECT', action.payload)
      return {
        ...state,
      }
    }
    //PROJEKT_ON_START_GET_FORTNOX_INVOICES_PROJECT,PROJEKT_ON_GET_FORTNOX_INVOICES_PROJECT,PROJEKT_ON_ERROR_GET_FORTNOX_INVOICES_PROJECT,
    case PROJEKT_ON_START_GET_FORTNOX_INVOICES_PROJECT: {
      console.log('PROJEKT_ON_START_GET_FORTNOX_INVOICES_PROJECT', action.payload)
      return {
        ...state
      }
    }
    case PROJEKT_ON_GET_FORTNOX_INVOICES_PROJECT: {
      console.log('PROJEKT_ON_GET_FORTNOX_INVOICES_PROJECT', action.payload)
      return {
        ...state,
        FortNoxProjektFakturor: action.payload.FortNoxProjektFakturor
      }
    }
    case PROJEKT_ON_ERROR_GET_FORTNOX_INVOICES_PROJECT: {
      console.log('PROJEKT_ON_ERROR_GET_FORTNOX_INVOICES_PROJECT', action.payload)
      return {
        ...state,
      }
    }
    //
    case PROJEKT_ON_START_ADD_EXTERN_PART_BOARD: {
      console.log("PROJEKT_ON_START_ADD_EXTERN_PART_BOARD", action.payload)
      return {
        ...state,
        BoardLoading: true,
        BoardResponse: null
      }
    }
    case PROJEKT_ON_ERROR_ADD_EXTERN_PART_BOARD: {
      console.log("PROJEKT_ON_ERROR_ADD_EXTERN_PART_BOARD", action.payload)
      return {
        ...state,
        BoardLoading: false,
        BoardResponse: { success: false, message: translate("Error.Project.External.part.Board.Add")}
      }
    }
    case PROJEKT_ON_ADD_EXTERN_PART_BOARD: {
      console.log('PROJEKT_ON_ADD_EXTERN_PART_BOARD', action.payload)
      return {
        ...state,
        BoardLoading: false,
        BoardResponse: { success: true, message: translate("Action.Project.External.part.Board.Add")},
        currentBoard: {
          ...state.currentBoard,
          ...action.payload.Board
        }
      }
    }
    case PROJEKT_ON_GET_BOARD_LIST_BY_TOKEN: {
      console.log("PROJEKT_ON_GET_BOARD_LIST_BY_TOKEN", action.payload)
      return {
        ...state,
        tokenBoardList: action.payload.tokenBoardList,
        currentExternErrorMsg: null
      }
    }
    case PROJEKT_ON_GET_BOARD_LIST_BY_USER: {
      console.log("PROJEKT_ON_GET_BOARD_LIST_BY_USER", action.payload)
      return {
        ...state,
        userBoardList: action.payload.userBoardList,
        currentExternErrorMsg: null
      }
    }
    case PROJEKT_ON_START_GET_BOARD_LIST_BY_TOKEN: {
      console.log("PROJEKT_ON_START_GET_BOARD_LIST_BY_TOKEN", action.payload)
      return {
        ...state,
        currentExternErrorMsg: null
      }
    }
    case PROJEKT_ON_ERROR_GET_BOARD_LIST_BY_TOKEN: {
      console.log("PROJEKT_ON_ERROR_GET_BOARD_LIST_BY_TOKEN", action.payload)
      return {
        ...state,
        currentExternErrorMsg: action.payload
      }
    }

    // PROJEKT_ON_GET_BOARD_BY_TOKEN,
    // PROJEKT_ON_START_GET_BOARD_BY_TOKEN,
    // PROJEKT_ON_ERROR_GET_BOARD_BY_TOKEN
      case PROJEKT_ON_START_GET_BOARD_BY_TOKEN: {
        console.log("PROJEKT_ON_START_GET_BOARD_BY_TOKEN", action)
        const Init = action.payload
        return {
          ...state,
          fetchingData: true,
          BoardResponse: null,
          currentBoard: isUndefined(Init) ? state.currentBoard : {},
          BoardLoading: isUndefined(Init) ? false : true,
          currentProject: isUndefined(Init) ? state.currentProject : {},
          currentExternUser: isUndefined(Init) ? state.currentExternUser : {},
          currentExternErrorMsg: null
        }
      }
      case PROJEKT_ON_GET_BOARD_BY_TOKEN: {
        console.log("PROJEKT_ON_GET_BOARD_BY_TOKEN", action)
        if(!action.payload.newData) return {...state, newData: false, fetchingData: false, boardDataFetched: true}
        return {
          ...state,
          fetchingData: false,
          newData: true,
          currentBoard: action.payload.board,
          currentProject: action.payload.projekt,
          currentExternUser: action.payload.ExternUser,
          boardDataFetched: true,
          BoardLoading: false,
          currentExternErrorMsg: null
        }
      }
      case PROJEKT_ON_ERROR_GET_BOARD_BY_TOKEN: {
        console.log("PROJEKT_ON_GET_BOARD_BY_TOKEN", action)
        return {
          ...state,
          fetchingData: false,
          newData: false,
          currentBoard: {},
          currentProject: {},
          currentExternUser: {},
          boardDataFetched: true,
          BoardLoading: false,
          currentExternErrorMsg: action.payload
        }
      }
      case PROJEKT_ON_RESET_BOARD_RESPONSE: {
        return {
          ...state,
          BoardResponse: null,
          BoardSaving: false
        }
      }
//PROJEKT_ON_START_GET_CARD_DETAILS,PROJEKT_ON_GET_CARD_DETAILS,PROJEKT_ON_ERROR_GET_CARD_DETAILS,
case PROJEKT_ON_START_GET_CARD_DETAILS: {
  console.log("PROJEKT_ON_START_ADD_EXTERN_PART_BOARD", action.payload)
  return {
    ...state,
    cardDetails: []
  }
}
case PROJEKT_ON_GET_CARD_DETAILS: {
  console.log("PROJEKT_ON_GET_CARD_DETAILS", action.payload)
  return {
    ...state,
    cardDetails: action.payload.cardDetails
  }
}
case PROJEKT_ON_ERROR_GET_GET_CARD_DETAILS: {
  console.log("PROJEKT_ON_ERROR_GET_CARD_DETAILS", action.payload)
  return {
    ...state,
  }
}
//cardDetails
    default: {
      return state
    }
  }
}
